import { render, staticRenderFns } from "./adverseReaction.vue?vue&type=template&id=4fcefd66&scoped=true&"
import script from "./adverseReaction.vue?vue&type=script&lang=js&"
export * from "./adverseReaction.vue?vue&type=script&lang=js&"
import style0 from "./adverseReaction.vue?vue&type=style&index=0&id=4fcefd66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcefd66",
  null
  
)

export default component.exports